import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { AlertCircle, CheckCircle2, Phone, Mail, User } from "lucide-react";

export function ContactSection({ formData, handleChange, emailError, phoneError, user, isEdit }) {
  return (
    <>
      {/* Name */}
      <div>
        <Label htmlFor="name">Full Name *</Label>
        <div className="relative mt-1">
          <User className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400" />
          <Input
            id="name"
            name="name"
            data-testid="lead-name-input"
            value={formData.name}
            onChange={handleChange}
            className="pl-10 h-11 rounded-sm"
            required
            placeholder="John Doe"
          />
        </div>
      </div>

      {/* Email and Phone - Hidden for Sourcing Managers */}
      {user.role !== 'sourcing_manager' && (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <Label htmlFor="email">Email *</Label>
            <div className="relative mt-1">
              <Mail className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400" />
              <Input
                id="email"
                name="email"
                type="email"
                data-testid="lead-email-input"
                value={formData.email}
                onChange={handleChange}
                className={`pl-10 h-11 rounded-sm pr-10 ${emailError ? 'border-red-500' : ''}`}
                required
                placeholder="john@example.com"
              />
              {emailError && <AlertCircle className="absolute right-3 top-1/2 -translate-y-1/2 h-4 w-4 text-red-500" />}
              {!emailError && formData.email && <CheckCircle2 className="absolute right-3 top-1/2 -translate-y-1/2 h-4 w-4 text-green-500" />}
            </div>
            {emailError && <p className="text-red-500 text-xs mt-1">{emailError}</p>}
          </div>

          <div>
            <Label htmlFor="phone">Phone *</Label>
            <div className="relative mt-1">
              <Phone className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400" />
              <Input
                id="phone"
                name="phone"
                data-testid="lead-phone-input"
                value={formData.phone}
                onChange={handleChange}
                className={`pl-10 h-11 rounded-sm pr-10 ${phoneError ? 'border-red-500' : ''}`}
                required
                placeholder="+91 9876543210"
              />
              {phoneError && <AlertCircle className="absolute right-3 top-1/2 -translate-y-1/2 h-4 w-4 text-red-500" />}
              {!phoneError && formData.phone && <CheckCircle2 className="absolute right-3 top-1/2 -translate-y-1/2 h-4 w-4 text-green-500" />}
            </div>
            {phoneError && <p className="text-red-500 text-xs mt-1">{phoneError}</p>}
          </div>
        </div>
      )}
      {user.role === 'sourcing_manager' && isEdit && (
        <div className="bg-amber-50 border border-amber-200 rounded-lg p-3">
          <p className="text-sm text-amber-700">Contact details are restricted. Please coordinate with CAPIN Realty admin for full lead contact information.</p>
        </div>
      )}
    </>
  );
}
